// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import {globalRegistryType} from '../../common/utils';
import {AddRegistryMemberDrawer} from './AddRegistryMemberDrawer';

type AddRegistryMemberProps = {
  registry: globalRegistryType;
};

export const AddRegistryMember = ({registry}: AddRegistryMemberProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <Button
        startIcon="add-new"
        variant="secondary"
        onClick={() => setIsModalOpen(true)}>
        Add access
      </Button>
      <AddRegistryMemberDrawer
        open={isModalOpen}
        closeDrawer={() => setIsModalOpen(false)}
        registry={registry}
      />
    </>
  );
};
